module.exports = __webpack_public_path__ + "d308073b/img/boston-lights.a623432f.png";